import React from "react";
import { Accept } from "react-dropzone";
import { withStyles } from "@material-ui/core";
import cns from "classnames";
import { transparentize } from "polished";
import CloudUploadIcon from "react-icons/lib/md/cloud-upload";
import CloudOffIcon from "react-icons/lib/md/cloud-off";
import { Classes, ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { Subheading } from "@components/typography/Subheading";

export type DnDOverlayProps = {
  classes: Classes<typeof styles>;
  className?: string;
  style?: React.CSSProperties;
  fullScreen?: boolean;
  titleAccept?: React.ReactNode;
  titleReject?: React.ReactNode;
  type: "accept" | "reject";
  accept: Accept;
};

function getExtensionsStr(accept: Accept): string {
  try {
    return [...new Set(Object.values(accept).flat())].join(", ");
  } catch (error) {
    return "";
  }
}

const DnDOverlay: React.FC<DnDOverlayProps> = (props) => {
  const { classes, fullScreen, type, className, ...rest } = props;

  const rootClassName = cns(classes.root, className, {
    [classes.fixed]: fullScreen,
    [classes.abs]: !fullScreen,
    [classes.dragAccept]: type === "accept",
    [classes.dragReject]: type === "reject"
  });

  const title =
    type === "accept"
      ? rest.titleAccept || locale.dropFilesToUpload
      : type === "reject"
      ? rest.titleReject || locale.getFileUploadError(getExtensionsStr(rest.accept))
      : "";

  const Icon = type === "accept" ? CloudUploadIcon : CloudOffIcon;

  return (
    <div className={rootClassName} style={props.style}>
      <div>
        <Icon size={48} />
      </div>
      <div>
        <Subheading color="inherit" style={{ color: "white" }}>
          {title}
        </Subheading>
      </div>
    </div>
  );
};

const styles = (theme: ThemeType) => ({
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    zIndex: 1200
  },

  abs: {
    ...theme.mixins.fullAbsolute
  },

  /** remove? */
  fixed: {
    ...theme.mixins.fullFixed
  },

  dragAccept: {
    backgroundColor: transparentize(0.15, theme.palette.secondary.main),
    color: theme.palette.common.white
  },

  dragReject: {
    backgroundColor: transparentize(0.15, theme.palette.primary.main),
    color: theme.palette.common.white
  }
});

export default withStyles(styles as any)(DnDOverlay);
